export enum SYSTEMS_NAMES {
  ga = 'ga',
  gtm = 'gtm',
  ga4 = 'ga4',
  amazon = 'amazon',
  amplitude = 'amplitude',
}

export const DEFAULT_EMPTY_URL_PARAMS = { data: 'empty_url_store' };
export const A_B_TEST_NAME = 'portal';
